// 管理員配置
export const ADMIN_EMAILS = [
  'admin@checkplay.com',
  'jeff@redball.com.tw'
];

export const ADMIN_NAMES = [
  'admin'
];

// 檢查是否為管理員
export const isAdminUser = (email?: string | null, name?: string | null): boolean => {
  if (!email && !name) return false;
  
  return (
    (email && ADMIN_EMAILS.includes(email)) ||
    (name && ADMIN_NAMES.includes(name))
  );
};

// 獲取管理員列表（用於顯示）
export const getAdminList = (): string[] => {
  return [...ADMIN_EMAILS, ...ADMIN_NAMES];
};
